import { useState } from "react";

import {
  BDP_FLOW,
  HDP_BASIC_FLOW,
  HDP_FULL_FLOW,
  HDP_MESSAGE_SCREENING_FLOW,
  HDP_POST_SUBMIT_FLOW
} from "../../constants/flows";
import {
  CONFIRMATION_MODAL_STEP,
  CONTACT_FORM_STEP,
  MESSAGE_SCREENING_STEP,
  POST_SUBMIT_QUESTIONNAIRE_STEP
} from "../../constants/steps";
import useEnhancedRef from "./useEnhancedRef";
import useFeatureState from "./useFeatureState";
import useUserProfileQuery from "./useUserProfileQuery";

const useFlow = () => {
  const { listingId } = useFeatureState();
  const onHDPPage = Boolean(listingId);
  const { showPostSubmitQuestionnaire } = useUserProfileQuery();

  let initialFlow;
  if (onHDPPage && showPostSubmitQuestionnaire) {
    initialFlow = HDP_POST_SUBMIT_FLOW;
  } else if (onHDPPage) {
    initialFlow = HDP_BASIC_FLOW;
  } else {
    initialFlow = BDP_FLOW;
  }

  const currentFlow = useEnhancedRef(initialFlow);

  const resetFlow = () => {
    currentFlow(initialFlow);
  };

  const setFlow = newFlow => {
    if (
      currentFlow() === HDP_POST_SUBMIT_FLOW &&
      newFlow === HDP_MESSAGE_SCREENING_FLOW
    ) {
      currentFlow(HDP_FULL_FLOW);
    } else {
      currentFlow(newFlow);
    }
  };

  const [currentStep, setCurrentStep] = useState(CONTACT_FORM_STEP);

  const resetStep = () => setCurrentStep(CONTACT_FORM_STEP);

  const advanceStep = () => {
    switch (currentStep) {
      case CONTACT_FORM_STEP:
        if (
          [HDP_FULL_FLOW, HDP_MESSAGE_SCREENING_FLOW].includes(currentFlow())
        ) {
          setCurrentStep(MESSAGE_SCREENING_STEP);
        } else if (currentFlow() === HDP_POST_SUBMIT_FLOW) {
          setCurrentStep(POST_SUBMIT_QUESTIONNAIRE_STEP);
        } else {
          setCurrentStep(CONFIRMATION_MODAL_STEP);
        }
        break;
      case MESSAGE_SCREENING_STEP:
        if (currentFlow() === HDP_FULL_FLOW) {
          setCurrentStep(POST_SUBMIT_QUESTIONNAIRE_STEP);
        } else {
          setCurrentStep(CONFIRMATION_MODAL_STEP);
        }
        break;
      case POST_SUBMIT_QUESTIONNAIRE_STEP:
        setCurrentStep(CONFIRMATION_MODAL_STEP);
        break;
      default:
        break;
    }
  };

  return [
    { currentFlow: currentFlow(), currentStep },
    { advanceStep, resetFlow, resetStep, setFlow }
  ];
};

export default useFlow;
